// 24 items in question order. reverse_scored = item subtracted from 6 before averaging.
export const QUESTIONS = [
  { number: 1, text: "I feel emotionally connected to my partner.", dimension: "emotional_connection", reverse_scored: false },
  { number: 2, text: "My partner shows interest in my thoughts and experiences.", dimension: "emotional_connection", reverse_scored: false },
  { number: 3, text: "We make time for meaningful conversation.", dimension: "emotional_connection", reverse_scored: false },
  { number: 4, text: "I feel valued and appreciated in this relationship.", dimension: "emotional_connection", reverse_scored: false },

  { number: 5, text: "I feel heard when I express concerns.", dimension: "communication", reverse_scored: false },
  { number: 6, text: "We try to understand each other before reacting.", dimension: "communication", reverse_scored: false },
  { number: 7, text: "We are able to discuss difficult issues calmly.", dimension: "communication", reverse_scored: false },
  { number: 8, text: "One or both of us becomes defensive quickly during disagreements.", dimension: "communication", reverse_scored: true },

  { number: 9, text: "We are able to recover after arguments.", dimension: "conflict_management", reverse_scored: false },
  { number: 10, text: "We work toward solutions rather than trying to “win.”", dimension: "conflict_management", reverse_scored: false },
  { number: 11, text: "We apologize when appropriate.", dimension: "conflict_management", reverse_scored: false },
  { number: 12, text: "Small disagreements tend to escalate quickly.", dimension: "conflict_management", reverse_scored: true },

  { number: 13, text: "I feel emotionally safe being vulnerable in this relationship.", dimension: "trust_safety", reverse_scored: false },
  { number: 14, text: "I trust my partner to care about my well-being.", dimension: "trust_safety", reverse_scored: false },
  { number: 15, text: "We are honest with each other about important matters.", dimension: "trust_safety", reverse_scored: false },
  { number: 16, text: "I worry that my feelings will be used against me.", dimension: "trust_safety", reverse_scored: true },

  { number: 17, text: "We speak to each other with kindness, even during conflict.", dimension: "respect_support", reverse_scored: false },
  { number: 18, text: "My partner supports my growth and goals.", dimension: "respect_support", reverse_scored: false },
  { number: 19, text: "We express appreciation for one another.", dimension: "respect_support", reverse_scored: false },
  { number: 20, text: "Criticism and put-downs are common in our relationship.", dimension: "respect_support", reverse_scored: true },

  { number: 21, text: "We work together effectively as a team.", dimension: "partnership", reverse_scored: false },
  { number: 22, text: "Decisions are made fairly in our relationship.", dimension: "partnership", reverse_scored: false },
  { number: 23, text: "We are able to solve problems together.", dimension: "partnership", reverse_scored: false },
  { number: 24, text: "We feel like partners rather than opponents.", dimension: "partnership", reverse_scored: false },
];

export const DIMENSION_META = [
  { key: "emotional_connection", name: "Emotional Connection & Friendship" },
  { key: "communication",       name: "Communication & Listening" },
  { key: "conflict_management", name: "Conflict Management & Repair" },
  { key: "trust_safety",        name: "Trust & Emotional Safety" },
  { key: "respect_support",     name: "Mutual Respect & Support" },
  { key: "partnership",         name: "Partnership & Teamwork" },
];

export const LIKERT_OPTIONS = [
  { value: 1, label: "Strongly disagree" },
  { value: 2, label: "Disagree" },
  { value: 3, label: "Neither agree nor disagree" },
  { value: 4, label: "Agree" },
  { value: 5, label: "Strongly agree" },
];
